import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth-store';

export function Logout() {
  const navigate = useNavigate();
  const { logout, isAuthenticated } = useAuthStore();
  const [isLoggingOut, setIsLoggingOut] = useState(true);

  useEffect(() => {
    const performLogout = async () => {
      try {
        await logout();
      } catch (error) {
        console.error('Logout error:', error);
      } finally {
        setIsLoggingOut(false);
      }
    };

    if (isAuthenticated) {
      performLogout();
    } else {
      // Already logged out
      setIsLoggingOut(false);
    }
  }, [logout, isAuthenticated]);

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        {isLoggingOut ? (
          <>
            <div className="flex flex-col items-center gap-4">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
              <p className="text-gray-600">Signing you out...</p>
            </div>
          </>
        ) : (
          <>
            <div>
              <svg
                className="mx-auto h-16 w-16 text-green-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <h2 className="mt-6 text-3xl font-extrabold text-gray-900">You've been signed out</h2>
              <p className="mt-2 text-sm text-gray-600">
                Thank you for using Acitra. See you next time!
              </p>
            </div>
            <button
              onClick={handleLoginRedirect}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
              Sign in again
            </button>
          </>
        )}
      </div>
    </div>
  );
}
